<template>
    <span class="ai-forge-name">{{ base }}<span v-if="forge" class="ai-forge-badge" title="Made from a screen recording in the Forge"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23z"/></svg>Built by the Forge</span></span>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

// A node name, with the "(Built by the Forge)" ending the Forge gives a kept
// recording's Video node (routes/ai.ts forgeVideoName) shown as a badge instead
export default defineComponent({
    name: 'AIForgeName',
    props: ['name'],
    computed: {
        forge(): boolean {
            return /\s*\(built by the forge\)$/i.test(String(this.name || ''));
        },
        base(): string {
            return String(this.name || '').replace(/\s*\(built by the forge\)$/i, '');
        }
    }
});
</script>

<style>
.ai-forge-badge { display: inline-flex; align-items: center; gap: 5px; margin-left: 8px; padding: 2px 9px 2px 7px; border-radius: 999px; background: linear-gradient(135deg, #f59e0b, #ea580c); color: #fff; font-size: 11.5px; font-weight: 700; letter-spacing: .02em; line-height: 18px; vertical-align: middle; white-space: nowrap; }
.ai-forge-badge svg { width: 11px; height: 11px; fill: currentColor; }
</style>
